<div class="modal-header">
  <h4 class="modal-title" id="export-csv-title">Download orders CSV</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p class="text-muted">
    Exports the orders created in the selected period (at most
    {{ maxRangeDays }} days).
  </p>

  <div class="form-check" *ngFor="let days of presets">
    <input
      class="form-check-input"
      type="radio"
      name="export-range"
      [id]="'export-range-' + days"
      [value]="days"
      [(ngModel)]="selected"
    />
    <label class="form-check-label" [for]="'export-range-' + days">
      Last {{ days }} days
    </label>
  </div>

  <div class="form-check">
    <input
      class="form-check-input"
      type="radio"
      name="export-range"
      id="export-range-custom"
      value="custom"
      [(ngModel)]="selected"
    />
    <label class="form-check-label" for="export-range-custom">
      Select a date range
    </label>
  </div>

  <div class="row mt-3" *ngIf="selected === 'custom'">
    <div class="col-md-6">
      <label for="export-start-date">Start date</label>
      <input
        id="export-start-date"
        type="date"
        class="form-control"
        [(ngModel)]="customStart"
        [max]="customEnd || today"
      />
    </div>
    <div class="col-md-6">
      <label for="export-end-date">End date</label>
      <input
        id="export-end-date"
        type="date"
        class="form-control"
        [(ngModel)]="customEnd"
        [min]="customStart"
        [max]="today"
      />
    </div>
  </div>

  <div class="text-danger mt-2" role="alert" *ngIf="error">{{ error }}</div>

  <div class="summary mt-3" *ngIf="range">
    <strong>{{ range.start_date | date : 'MMM d, y' }}</strong>
    to
    <strong>{{ range.end_date | date : 'MMM d, y' }}</strong>
    ({{ dayCount }} {{ dayCount === 1 ? 'day' : 'days' }})
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss('Cancel')"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!range"
    (click)="download()"
  >
    Download
  </button>
</div>
